const base = 'skeleton rounded';

const variants = {
  text: 'h-4 w-full',
  title: 'h-6 w-1/3',
  avatar: 'h-10 w-10 rounded-full',
  'stat-card': 'h-28 w-full rounded-xl',
  card: 'h-40 w-full rounded-xl',
  'table-row': 'h-12 w-full',
};

const Skeleton = ({ variant = 'text', count = 1, className = '' }) => {
  const classes = `${base} ${variants[variant] || variants.text} ${className}`;
  if (count === 1) {
    return <div className={classes} aria-hidden="true" />;
  }
  return (
    <div className="space-y-2" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={classes} />
      ))}
    </div>
  );
};

export default Skeleton;
